import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'
import * as rd from "diacritics"

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Label
} from 'react-bootstrap';

import '../../statics/css/table-exercises.css'
import '../../statics/css/util.css'
import { categorysListUtils } from '../../utils/categorys-exercises';
import TableExercises from './table-exercises';

import If from "../../utils/If"

class TabsExercises extends Component {

  constructor(props) {
    super(props);

    this.state = {
      exercises_map_search: {},
      first_visible_tab: 1,
      selected_key: undefined,
    };

  }

  componentDidMount() {

  }

  componentWillMount() {

  }

  handleEditExercise(exercise) {
    this.props.handleEditExercise(exercise)
  }

  handleRemoveExercise(exercise) {
    this.props.handleRemoveExercise(exercise)
  }

  exercisesToSearch(exercises, category) {

    //console.log("CATEGORY: " + category)

    this.state.exercises_map_search[category] = exercises;
    this.setState({
      exercises_map_search: this.state.exercises_map_search,
    }, () => {
      //console.log("MAP SEARCH EXERCISES")
      // console.log(this.state.exercises_map_search)
    })
  }

  //Verifica se o texto digitado coincide com algum nome de toda a lista
  //de exercícios da categoria
  verifySearchInCategory(category) {

    if (this.state.exercises_map_search[category]) {
      let searchFormat = rd.remove(this.props.search.toLowerCase());

      //console.log("LENGHT: " + this.state.exercises_map_search[category].length);
      for (let i = 0; i < this.state.exercises_map_search[category].length; i++) {
        let nameObjFormat = rd.remove(this.state.exercises_map_search[category][i].data.name.toLowerCase());

        if (nameObjFormat.includes(searchFormat)) {
          //console.log(nameObjFormat + "includes(" + searchFormat + ") = " + nameObjFormat.includes(searchFormat))
          return true;
        }
      }
    }

    return false;
  }

  //retorno p primeiro indice visivel das tabs
  getFirstVisibleTab() {

    let count = 1;
    for (let k in this.state.exercises_map_search) {
      if (this.state.exercises_map_search.hasOwnProperty(k)) {
        if (this.state.exercises_map_search[k].length > 0 && this.verifySearchInCategory(k)) {
          console.log("FIRST: " + count + " - " + k)
          if (this.state.first_visible_tab != count) {
            this.setState({
              selected_key: undefined,
              first_visible_tab: count,
            })
          }
          return count;
        }
        ++count;
      }
    }
    //console.log("FIRST VISIBLE: " + count);
  }

  handleSelectTab() {

  }

  renderExercisesTabs() {

    console.log("CATEGORIAS: ", categorysListUtils)

    return _.map(categorysListUtils, (category, index) => {

      return (

        //<If test={!this.state.exercises_search}>
        <Tab eventKey={index + 1} title={category.name} tabClassName={`teste-class ${this.state.exercises_map_search && this.verifySearchInCategory(category.key) ? '' : 'display-none'} ${(index + 1 == this.getFirstVisibleTab() && !this.state.selected_key) || (index + 1 == this.state.selected_key) ? 'active' : ''}`}>
          <TableExercises handleEditExercise={(exercise) => this.handleEditExercise(exercise)} handleRemoveExercise={(exercise) => this.handleRemoveExercise(exercise)} category={category.key} exercisesToSearch={(exercises, category) => this.exercisesToSearch(exercises, category)} search={this.props.search} />
        </Tab >
        //</If>

      )

    })
  }

  handleSelect(key) {
    //console.log("KEY:" + key)
    this.setState({
      selected_key: key,
    });
  }

  render() {

    return (

      <Tabs onSelect={(e) => this.handleSelect(e)} activeKey={this.state.selected_key ? this.state.selected_key : this.state.first_visible_tab} animation={false} id="tabs-exercises" className={this.props.customClass ? this.props.customClass : ""}>
        {this.renderExercisesTabs()}
      </Tabs>

    );
  }
}

export default TabsExercises;



// WEBPACK FOOTER //
// src/components/treinos/tabs-exercises.js